import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { RouterContext } from '@/types/routerContext.tsx';
import Header from '@/web/components/molecules/Header';
import UnAuthorizedErrorBoundary from '@/web/components/molecules/UnAuthorizedErrorBoundary';
import PageErrorBoundary from '@/web/components/molecules/PageErrorBoundary';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});
const MAX_RETRIES = 1;
function shouldRetry(failureCount: number, error: Error) {
  return failureCount < MAX_RETRIES;
}

function RootComponent() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        retryDelay: 1000,
      },
      mutations: {
        retry: 3,
        retryDelay: 1000,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <UnAuthorizedErrorBoundary>
        <Header />
        <div className="page-container">
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </div>

      </UnAuthorizedErrorBoundary>
    </QueryClientProvider>
  )
}
